import { IHunterNew, IHuntersFilterOptions } from '@app/interfaces/hunter';
import { IPagination } from '@app/interfaces/pagination';
import { initialPagination } from '@app/constants/pagination';

export interface IHuntersTableData {
  data: IHunterNew[];
  pagination: IPagination;
  filterOptions: IHuntersFilterOptions;
  loading: boolean;
  error: boolean;
}

export const tableDataInit: IHuntersTableData = {
  data: [],
  pagination: initialPagination,
  filterOptions: {
    uniqueStatuses: [
      {
        name: 'active',
        labelEn: 'Active',
        labelDe: 'Aktiv',
        labelFr: 'Actif',
        labelIt: 'Attivo',
        getter: null,
        setter: null,
      },
      {
        name: 'banned',
        labelEn: 'Banned',
        labelDe: 'Gebannt',
        labelFr: 'Banni',
        labelIt: 'Bannato',
        getter: null,
        setter: null,
      },
      {
        name: 'unverified',
        labelEn: 'Unverified',
        labelDe: 'Unbestätigt',
        labelFr: 'Non vérifié',
        labelIt: 'Non verificato',
        getter: 'getIsEmailVerified',
        setter: 'setIsEmailVerified',
      },
      {
        name: 'blocked',
        labelEn: 'Blocked',
        labelDe: 'Gesperrt',
        labelFr: 'Bloqué',
        labelIt: 'Bloccato',
        getter: 'getBlockedAt',
        setter: 'setBlockedAt',
      },
      {
        name: 'archived',
        labelEn: 'Archived',
        labelDe: 'Archiviert',
        labelFr: 'Archivé',
        labelIt: 'Archiviato',
        getter: 'getSoftDeleted',
        setter: 'setSoftDeleted',
      },
    ],
    uniqueMembershipStatuses: [
      {
        labelEn: 'Active',
        labelFr: 'Actif',
        labelDe: 'Aktiv',
        labelIt: 'Attivo',
        value: 'active',
      },
      {
        labelEn: 'Pending',
        labelFr: 'En attente',
        labelDe: 'Ausstehend',
        labelIt: 'In attesa',
        value: 'pending',
      },
      {
        labelEn: 'Suspended',
        labelFr: 'Suspendu',
        labelDe: 'Suspendiert',
        labelIt: 'Sospeso',
        value: 'suspended',
      },
      {
        labelEn: 'Inactive',
        labelFr: 'Inactif',
        labelDe: 'Inaktiv',
        labelIt: 'Inattivo',
        value: 'inactive',
      },
    ],
    uniqueMembershipTypes: [],
    uniqueMembershipPaymentDoneTypes: [
      { value: 1, labelEn: 'Paid', labelDe: 'Bezahlt', labelFr: 'Payé', labelIt: 'Pagato' },
      { value: 0, labelEn: 'Not Paid', labelDe: 'Nicht Bezahlt', labelFr: 'Non Payé', labelIt: 'Non Pagato' },
    ],
  },
  loading: false,
  error: false,
};
